import React from 'react'
import { connect } from 'react-redux'
import { array, object, func } from 'prop-types'
import { NavDropdown, MenuItem } from 'react-bootstrap'
import { changeActiveAccount } from '../actions'

const AccountChooser = ({
  activeAccount,
  accounts,
  changeActiveAccount
}) => (
  <ul className='nav navbar-nav'>
    <NavDropdown title={(activeAccount && activeAccount.name) || 'Selecione uma conta '} id='basic-nav-dropdown'>
      {accounts.map((account) => {
        return (
          <MenuItem key={account._id} onClick={() => { changeActiveAccount(account._id) }}>{account.name}</MenuItem>
        )
      })}
    </NavDropdown>
  </ul>
)

AccountChooser.propTypes = {
  activeAccount: object,
  accounts: array,
  changeActiveAccount: func
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeActiveAccount: (id) => {
      dispatch(changeActiveAccount(id))
    }
  }
}

const mapStateToProps = (state) => {
  return {
    activeAccount: state.app.activeAccount,
    accounts: state.app.accounts
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountChooser)



// WEBPACK FOOTER //
// ./src/components/AccountChooser.js